/**
 * @file index.tsx
 *
 * @fileoverview Shows a placeholder when a organization teaser card is loading.
 */

import ContentLoader from "react-content-loader";
import styles from "./teaserPlaceholder.module.scss";

/**
 * Placeholder skeleton for organization teaser for when card is loading.
 * Skeletons help provide some guidance to the user for
 * what the page will have while content is loading.
 */
export const OrganizationTeaserPlaceholder = () => (
  <div className={styles.organizationTeaserPlaceholderWrapper}>
    <ContentLoader
      // @ts-ignore.
      viewBox="0 0 500 500"
      height={500}
      width={500}
      style={{ background: "#fff" }}
      uniqueKey="org-teaser"
    >
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="200" />
      <rect x="20" y="150" rx="2" ry="2" width="100" height="100" />
      <rect x="20" y="270" rx="2" ry="2" width="275" height="15" />
      <rect x="20" y="290" rx="2" ry="2" width="140" height="15" />
      <rect x="20" y="330" rx="2" ry="2" width="300" height="15" />
      <rect x="20" y="355" rx="2" ry="2" width="300" height="15" />
      <rect x="20" y="380" rx="2" ry="2" width="300" height="15" />
      <rect x="20" y="420" rx="2" ry="2" width="100" height="25" />
    </ContentLoader>
  </div>
);
